import { get } from "./http.js";
import { API } from "../config/api.js";

/** Read bb_user from localStorage safely */
export function getStoredAuthUser() {
  try {
    const raw = localStorage.getItem("bb_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getStoredUserId(stored = null) {
  const s = stored || getStoredAuthUser();
  if (!s) return "";
  const id = s.id ?? s._id ?? s.userId ?? "";
  return id ? String(id) : "";
}

export function getStoredToken(stored = null) {
  const s = stored || getStoredAuthUser();
  return s?.token || "";
}

/**
 * Normalize getUserById / refresh responses (handles { data: user } if interceptor missed unwrap).
 */
export function normalizeProfileResponse(raw) {
  if (!raw || typeof raw !== "object") return null;

  let u = raw;
  if (raw.data && typeof raw.data === "object" && !Array.isArray(raw.data)) {
    u = raw.data;
  } else if (raw.user && typeof raw.user === "object") {
    u = raw.user;
  }

  const id = u._id ?? u.id ?? u.userId;
  if (!id && !u.mobile && !u.name && !u.email) return null;

  const mobile = u.mobile ?? u.phone ?? "";
  return {
    ...u,
    id: String(id ?? u.mobile ?? ""),
    _id: u._id ?? id,
    mobile,
    phone: u.phone ?? mobile,
    avatar: u.avatar ?? u.profileImage ?? null,
    profileImage: u.profileImage ?? u.avatar ?? null,
  };
}

/** Fetch profile from API; returns null on failure (does not throw). */
export async function fetchUserProfile(userId, token) {
  if (!userId || !token) return null;
  try {
    const res = await get(`${API.auth.getProfile}/${userId}`, {
      skipAuthClear: true,
      headers: { Authorization: `Bearer ${token}` },
    });
    return normalizeProfileResponse(res);
  } catch (err) {
    console.warn("[profile] fetch failed:", err?.message || err);
    return null;
  }
}
